export default __webpack_public_path__ + "static/media/car.7e53de6b.svg";